export default "__VITE_ASSET__C7eny$yZ__"